// extracted by mini-css-extract-plugin
export default {"wrapper":"tH","content":"uH","firstSection":"vH","text":"wH","table":"xH","tableText":"yH","row":"zH","column_2":"AH","column_1":"BH","column_3":"CH"};
    if(module.hot) {
      // 1713969934078
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  